import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeBaseComponent } from 'src/app/_core';
import { CustomOverlayRef } from 'src/app/_core/services/overlay.service';
import { AccButtonComponent } from 'src/app/_shared/components/acc-button/acc-button.component';
import { IconComponent } from 'src/app/_shared/components/icon/icon.component';

@Component({
  standalone: true,
  selector: 'neopos-modal-register-summary',
  templateUrl: './modal-register-summary.component.html',
  styles: [
    `
      :host {
        display: block;
        width: -webkit-fill-available;
        overflow: hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, IconComponent, AccButtonComponent],
})
export class ModalRegisterSummaryComponent extends ThemeBaseComponent {
  private readonly _dialogRef = inject(CustomOverlayRef);

  close = () => this._dialogRef.close();
}
